import { useI18n } from "../context/I18nContext";
import { Overline, Reveal } from "./Reveal";

export default function MenusSection() {
  const { t } = useI18n();

  return (
    <section id="menus" data-testid="menus-section" className="bg-bone py-24 text-charcoal md:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>{t.menus.overline}</Overline>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-3xl leading-tight sm:text-4xl lg:text-5xl">
              {t.menus.title}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-charcoal/60">{t.menus.note}</p>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          {t.menus.rows.map((r, i) => (
            <Reveal key={r.n} delay={0.08 * i}>
              <div
                data-testid={`menu-row-${r.n}`}
                className={`flex items-center justify-between gap-6 py-8 ${i > 0 ? "border-t border-charcoal/15" : ""}`}
              >
                <div className="flex items-baseline gap-5">
                  <span className="font-corm text-5xl italic leading-none text-terra md:text-6xl">{r.n}</span>
                  <span className="font-serif text-2xl md:text-3xl">{r.label}</span>
                </div>
                <div className="text-right">
                  <span className="font-corm text-3xl italic text-charcoal md:text-4xl">{r.price} €</span>
                  <span className="block text-[10px] uppercase tracking-[0.2em] text-stonekw">
                    {t.menus.perPerson}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
